import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	type useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type TranslateFunction = ReturnType<typeof useResource>["t"];

export const getPortfolioCurrencySign = (
	t: TranslateFunction,
	currency: CurrencyEnum | string,
) =>
	t(
		Resources.PortfolioDetail.SharedLabels.Currency[currency as CurrencyEnum],
	) ?? t(Resources.Common.CurrencySign);
